import { useSyncExternalStore } from "react";
import { tokenManager } from "./apiutils";

// Реактивный флаг авторизации: обновляется при входе/выходе/неудачном refresh
export const useAuth = () =>
  useSyncExternalStore(tokenManager.subscribe, tokenManager.isAuthenticated);
